"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SimpleFullScreenDialog = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importDefault(require("react"));
var react_common_lib_1 = require("@esub-engineering/react-common-lib");
var FullScreenDialogNavBar_1 = require("../../molecules/FullScreenDialogNavBar");
var atoms_1 = require("../../atoms");
var FullScreenDialog_1 = require("../FullScreenDialog");
exports.SimpleFullScreenDialog = react_1.default.memo(function (_a) {
    var title = _a.title, subtitle = _a.subtitle, _b = _a.buttonProps, buttonProps = _b === void 0 ? [] : _b, _c = _a.onClose, onClose = _c === void 0 ? function () { } : _c, children = _a.children, rest = __rest(_a, ["title", "subtitle", "buttonProps", "onClose", "children"]);
    var buttons = react_1.default.useMemo(function () {
        return (0, react_common_lib_1.valueToArray)(buttonProps).map(function (_a) {
            var _b = _a.type, type = _b === void 0 ? 'button' : _b, more = __rest(_a, ["type"]);
            return ((0, jsx_runtime_1.jsx)(atoms_1.Button, __assign({ size: "small", variant: "contained", type: type }, more), more.id));
        });
    }, [buttonProps]);
    return ((0, jsx_runtime_1.jsxs)(FullScreenDialog_1.FullScreenDialog, __assign({}, rest, { children: [(0, jsx_runtime_1.jsx)(FullScreenDialogNavBar_1.FullScreenDialogNavBar, { title: title, buttons: buttons, onClose: onClose, subtitle: subtitle }), (0, jsx_runtime_1.jsx)(atoms_1.FullScreenDialogContent, { children: children })] })));
});
